(function() {
    //Loading the section in case the user applied more than one time within 90 days
    function afAlreadyAppliedCheck() {
        const alreadyApplied = JSON.parse(localStorage.getItem("afAlreadyApplied"));
        if (alreadyApplied) {
            const alreadyAppliedDate = new Date(alreadyApplied.date);
            const today = new Date();
            const newDate = new Date(alreadyApplied.date);
            newDate.setDate(alreadyAppliedDate.getDate() + 90);
            //If number of applications exceeds 3
            if(alreadyApplied.number > 0 && newDate > today) {
                if (alreadyApplied.number >= 3) {
                    if (!document.querySelectorAll(".neos-backend").length) {
                        window.open(document.getElementById("already-applied-for-a-job").dataset.url, '_self')
                    }
                }
                else {
                    document.getElementById("already-applied-for-a-job").className = "";
                    document.getElementById("af-job-application-form-placeholder").className = "af-application-form-disabled";
                }
            }
        }
    }
    window.addEventListener("load",afAlreadyAppliedCheck);

    //Removing already applied section on a button click
    function afRemoveAlreadyAppliedSection() {
        document.getElementById("already-applied-for-a-job").className = "already-applied-for-a-job-hidden";
        document.getElementById("af-job-application-form-placeholder").className = "";
    }

    document.getElementById("already-applied-for-a-job-close").addEventListener("click",afRemoveAlreadyAppliedSection);
    document.querySelectorAll("#already-applied-for-a-job .button")[0].addEventListener("click",afRemoveAlreadyAppliedSection);

    //Taking user to the multiple application section in case filling the form is forbiden
    function afTakingUserToTheMultipleApplicationSection() {
        window.scrollTo({
            top: document.getElementById("already-applied-for-a-job"),
            behavior: "smooth"
        });
    }

    document.getElementById("af-job-application-form-placeholder-overlay").addEventListener("click",afTakingUserToTheMultipleApplicationSection)

})();
